<template>
    <div class="font-sans bg-[#f6f4f1] text-[#1f2937] min-h-screen flex flex-col">
        <!-- 🌟 HEADER -->
        <AppHeader />

        <div class="md:hidden w-full px-4 mt-4">
            <button @click="showFilters = true"
                class="w-full py-3 rounded-xl bg-[#b99a52] text-white font-semibold shadow">
                Filtrar Projetos
            </button>
        </div>

        <!-- MAIN CONTENT WRAPPER -->
        <section class="grid grid-cols-1 md:grid-cols-12 max-w-7xl mx-auto w-full px-4 py-6 gap-6">
            <aside
                class="hidden md:block md:col-span-3 lg:col-span-3 bg-white p-5 rounded-2xl shadow border border-[#e0dcd6] h-fit space-y-6 sticky top-24 self-start">

                <h2 class="text-xl font-semibold text-[#152a34]">Filtros</h2>
                <!-- BUSCA -->
                <div>
                    <label class="text-sm font-medium">Pesquisar</label>
                    <input v-model="filters.search" type="text" placeholder="Buscar..." class="input-gold" />
                </div>

                <!-- CATEGORIA -->
                <div>
                    <label class="text-sm font-medium">Categorias</label>

                    <!-- chips -->
                    <div v-if="selectedCategories.length" class="flex flex-wrap gap-2 mt-2">
                        <button v-for="c in selectedCategories" :key="c" type="button"
                            class="px-3 py-1 text-xs bg-[#f4efe6] border border-[#d6c7a5] text-[#6d5d3a] rounded-full"
                            @click="removeCategory(c)" title="Remover">
                            {{ c }} ✕
                        </button>
                    </div>

                    <!-- busca -->
                    <div class="relative mt-2">
                        <input
                            :value="categorySearch"
                            @input="onCategorySearch"
                            type="text"
                            placeholder="Digite para buscar categorias..."
                            class="input-gold pr-9"
                        />
                        <span v-if="categoryLoading" class="mdi mdi-loading animate-spin absolute right-3 top-1/2 -translate-y-1/2 text-[#b99a52] text-base pointer-events-none"></span>

                        <!-- dropdown -->
                        <div
                            ref="categoryDropdownDesktopRef"
                            v-if="categoryLoading || categoryOptions.length"
                            class="absolute top-full mt-1 left-0 right-0 bg-white border rounded-xl shadow-lg z-10 max-h-56 overflow-auto"
                            :style="categoryDropdownStyle"
                        >
                            <div v-if="categoryLoading" class="px-3 py-3 flex items-center gap-2 text-sm text-gray-400">
                                <span class="mdi mdi-loading animate-spin text-base shrink-0"></span>
                                <span>Buscando categorias...</span>
                            </div>
                            <template v-else>
                                <button v-for="opt in categoryOptions" :key="opt.id" type="button"
                                    class="w-full text-left px-3 py-2 hover:bg-gray-50 active:bg-gray-100 text-sm border-b border-gray-100 last:border-0"
                                    @click="addCategory(opt.description)">
                                    {{ opt.description }}
                                </button>
                            </template>
                        </div>
                    </div>
                </div>

                <!-- STATUS -->
                <!--<div>
                    <label class="text-sm font-medium">Status</label>
                    <div class="space-y-1 mt-1">
                        <div v-for="s in ['open', 'in_progress', 'awaiting_payment', 'awaiting_approval', 'payment_approved', 'completed', 'cancelled', 'dispute_opened', 'cancel_requested']"
                            :key="s" class="flex items-center gap-2">
                            <input type="checkbox" v-model="filters.status" :value="s" />
                            <span class="text-sm capitalize">
                                {{
                                    s === 'open' ? 'Aberto' :
                                        s === 'in_progress' ? 'Em andamento' :
                                            s === 'awaiting_payment' ? 'Aguardando pagamento' :
                                                s === 'awaiting_approval' ? 'Aguardando aprovação' :
                                                    s === 'payment_approved' ? 'Pagamento aprovado' :
                                                        s === 'completed' ? 'Concluído' :
                                                            s === 'dispute_opened' ? 'Disputa aberta' :
                                                                s === 'cancel_requested' ? 'Cancelamento solicitado' :
                                                                    'Cancelado'
                                }}
                            </span>
                        </div>
                    </div>
                </div>-->

                <!-- URGÊNCIA -->
                <div>
                    <label class="text-sm font-medium">Urgência</label>
                    <div class="space-y-1 mt-1">
                        <div v-for="u in ['low', 'medium', 'high']" :key="u" class="flex items-center gap-2">
                            <input type="checkbox" v-model="filters.urgency" :value="u" />
                            <span class="text-sm capitalize">
                                {{
                                    u === 'high' ? 'Alta' :
                                        u === 'medium' ? 'Média' : 'Baixa'
                                }}
                            </span>
                        </div>
                    </div>
                </div>

                <!-- ORÇAMENTO -->
                <!--<div>
                    <label class="text-sm font-medium">Orçamento</label>
                    <div class="flex gap-2 mt-1">
                        <input type="number" v-model="filters.budgetMin" placeholder="Mín."
                            class="w-1/2 px-3 py-2 rounded-xl border" />
                        <input type="number" v-model="filters.budgetMax" placeholder="Máx."
                            class="w-1/2 px-3 py-2 rounded-xl border" />
                    </div>
                </div>-->

                <!-- PROPOSTAS -->
                <div>
                    <label class="text-sm font-medium">Propostas</label>
                    <select v-model="filters.proposals" class="input-gold">
                        <option value="">Qualquer</option>
                        <option value="none">Sem propostas</option>
                        <option value="1-5">1 a 5 propostas</option>
                        <option value="5+">Mais de 5</option>
                    </select>
                </div>

                <!-- DATA DE PUBLICAÇÃO -->
                <div>
                    <label class="text-sm font-medium">Publicados</label>
                    <select v-model="filters.date" class="input-gold">
                        <option value="">Qualquer data</option>
                        <option value="1">Últimas 24h</option>
                        <option value="3">Últimos 3 dias</option>
                        <option value="7">Últimos 7 dias</option>
                        <option value="30">Últimos 30 dias</option>
                    </select>
                </div>

                <!-- DEADLINE -->
                <div>
                    <label class="text-sm font-medium">Deadline</label>
                    <select v-model="filters.deadline" class="input-gold">
                        <option value="">Qualquer</option>
                        <option value="3">Até 3 dias</option>
                        <option value="7">Até 7 dias</option>
                        <option value="15">Até 15 dias</option>
                        <option value="30">Até 30 dias</option>
                    </select>
                </div>

                <!-- ORDENAR -->
                <div>
                    <label class="text-sm font-medium">Ordenar por</label>
                    <select v-model="filters.order" class="input-gold">
                        <option value="recent">Mais recentes</option>
                        <option value="views">Mais visualizados</option>
                        <option value="proposals">Mais propostas</option>
                    </select>
                </div>

                <button @click="applyFilters"
                    class="w-full py-3 rounded-xl bg-[#b99a52] hover:bg-[#a18446] text-white font-semibold shadow mt-2">
                    Aplicar filtros
                </button>

            </aside>

            <!-- DRAWER MOBILE -->
            <div v-if="showFilters" class="fixed inset-0 bg-black/40 backdrop-blur-sm z-[999] flex md:hidden">

                <div class="w-80 bg-white h-full p-6 overflow-y-auto relative shadow-xl animate-slideLeft">

                    <!-- Botão fechar -->
                    <button @click="showFilters = false" class="absolute top-4 right-4 text-gray-500 text-xl">
                        ✕
                    </button>

                    <h2 class="text-xl font-semibold mb-4">Filtros</h2>

                    <!-- 🔥 TODOS OS CAMPOS AQUI -->
                    <div class="space-y-6">

                        <!-- BUSCA -->
                        <div>
                            <label class="text-sm font-medium">Pesquisar</label>
                            <input v-model="filters.search" type="text" placeholder="Buscar..."
                                class="w-full mt-1 px-3 py-2 rounded-xl border focus:ring-2 focus:ring-[#b99a52]" />
                        </div>

                        <!-- CATEGORIA -->
                        <div>
                            <label class="text-sm font-medium">Categorias</label>

                            <!-- chips -->
                            <div v-if="selectedCategories.length" class="flex flex-wrap gap-2 mt-2">
                                <button v-for="c in selectedCategories" :key="c" type="button"
                                    class="px-3 py-1 text-xs bg-[#f4efe6] border border-[#d6c7a5] text-[#6d5d3a] rounded-full"
                                    @click="removeCategory(c)" title="Remover">
                                    {{ c }} ✕
                                </button>
                            </div>

                            <!-- busca -->
                            <div class="relative mt-2">
                                <input
                                    :value="categorySearch"
                                    @input="onCategorySearch"
                                    type="text"
                                    placeholder="Digite para buscar categorias..."
                                    class="input-gold pr-9"
                                />
                                <span v-if="categoryLoading" class="mdi mdi-loading animate-spin absolute right-3 top-1/2 -translate-y-1/2 text-[#b99a52] text-base pointer-events-none"></span>

                                <!-- dropdown -->
                                <div
                                    ref="categoryDropdownMobileRef"
                                    v-if="categoryLoading || categoryOptions.length"
                                    class="absolute top-full mt-1 left-0 right-0 bg-white border rounded-xl shadow-lg z-10 max-h-44 overflow-auto"
                                    :style="categoryDropdownStyle"
                                >
                                    <div v-if="categoryLoading" class="px-3 py-3 flex items-center gap-2 text-sm text-gray-400">
                                        <span class="mdi mdi-loading animate-spin text-base shrink-0"></span>
                                        <span>Buscando categorias...</span>
                                    </div>
                                    <template v-else>
                                        <button v-for="opt in categoryOptions" :key="opt.id" type="button"
                                            class="w-full text-left px-3 py-2 hover:bg-gray-50 active:bg-gray-100 text-sm border-b border-gray-100 last:border-0"
                                            @click="addCategory(opt.description)">
                                            {{ opt.description }}
                                        </button>
                                    </template>
                                </div>
                            </div>
                        </div>

                        <!-- STATUS -->
                        <!--<div>
                            <label class="text-sm font-medium">Status</label>
                            <div class="space-y-1 mt-1">
                                <div v-for="s in ['open', 'in_progress', 'awaiting_payment', 'awaiting_approval', 'payment_approved', 'completed', 'cancelled']"
                                    :key="s" class="flex items-center gap-2">
                                    <input type="checkbox" v-model="filters.status" :value="s" />
                                    <span class="text-sm capitalize">
                                        {{
                                            s === 'open' ? 'Aberto' :
                                                s === 'in_progress' ? 'Em andamento' :
                                                    s === 'awaiting_payment' ? 'Aguardando pagamento' :
                                                        s === 'awaiting_approval' ? 'Aguardando aprovação' :
                                                            s === 'payment_approved' ? 'Pagamento aprovado' :
                                                                s === 'completed' ? 'Concluído' : 'Cancelado'
                                        }}
                                    </span>
                                </div>
                            </div>
                        </div>

                        <!-- URGÊNCIA -->
                        <div>
                            <label class="text-sm font-medium">Urgência</label>
                            <div class="space-y-1 mt-1">
                                <div v-for="u in ['low', 'medium', 'high']" :key="u" class="flex items-center gap-2">
                                    <input type="checkbox" v-model="filters.urgency" :value="u" />
                                    <span class="text-sm capitalize">
                                        {{
                                            u === 'high' ? 'Alta' :
                                                u === 'medium' ? 'Média' : 'Baixa'
                                        }}
                                    </span>
                                </div>
                            </div>
                        </div>

                        <!-- ORÇAMENTO -->
                        <!--<div>
                            <label class="text-sm font-medium">Orçamento</label>
                            <div class="flex gap-2 mt-1">
                                <input type="number" v-model="filters.budgetMin" placeholder="Mín."
                                    class="w-1/2 px-3 py-2 rounded-xl border" />
                                <input type="number" v-model="filters.budgetMax" placeholder="Máx."
                                    class="w-1/2 px-3 py-2 rounded-xl border" />
                            </div>
                        </div>-->

                        <!-- PROPOSTAS -->
                        <div>
                            <label class="text-sm font-medium">Propostas</label>
                            <select v-model="filters.proposals" class="input-gold">
                                <option value="">Qualquer</option>
                                <option value="none">Sem propostas</option>
                                <option value="1-5">1 a 5 propostas</option>
                                <option value="5+">Mais de 5</option>
                            </select>
                        </div>

                        <!-- DATA DE PUBLICAÇÃO -->
                        <div>
                            <label class="text-sm font-medium">Publicados</label>
                            <select v-model="filters.date" class="input-gold">
                                <option value="">Qualquer data</option>
                                <option value="1">Últimas 24h</option>
                                <option value="3">Últimos 3 dias</option>
                                <option value="7">Últimos 7 dias</option>
                                <option value="30">Últimos 30 dias</option>
                            </select>
                        </div>

                        <!-- DEADLINE -->
                        <div>
                            <label class="text-sm font-medium">Deadline</label>
                            <select v-model="filters.deadline" class="input-gold">
                                <option value="">Qualquer</option>
                                <option value="3">Até 3 dias</option>
                                <option value="7">Até 7 dias</option>
                                <option value="15">Até 15 dias</option>
                                <option value="30">Até 30 dias</option>
                            </select>
                        </div>

                        <!-- ORDENAR -->
                        <div>
                            <label class="text-sm font-medium">Ordenar por</label>
                            <select v-model="filters.order" class="input-gold">
                                <option value="recent">Mais recentes</option>
                                <option value="views">Mais visualizados</option>
                                <option value="proposals">Mais propostas</option>
                            </select>
                        </div>
                    </div>

                    <button @click="applyFilters(); showFilters = false"
                        class="mt-6 block w-full bg-[#b99a52] hover:bg-[#a18446] text-white py-3 rounded-xl font-semibold text-center">
                        Aplicar filtros
                    </button>
                </div>

                <!-- clique fora para fechar -->
                <div class="flex-1" @click="showFilters = false"></div>
            </div>

            <!-- 🔶 LISTA DE CARDS -->
            <div class="md:col-span-9 lg:col-span-9 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 items-start">
                <!-- CARD DO PROJETO -->
                <div v-for="project in projects" :key="project.id"
                    class="relative bg-white rounded-2xl shadow hover:shadow-xl transition p-6 border flex flex-col justify-between min-h-[450px]"
                    :class="{
                        'before:absolute before:left-0 before:top-0 before:h-full before:w-1.5 before:bg-red-500': project.urgency_level === 'high',
                    }">

                    <!-- ❤️ FAVORITO -->
                    <button @click="toggleFavorite(project.id)" class="absolute top-4 right-4 transition">
                        <svg v-if="favorites.includes(project.id)" xmlns="http://www.w3.org/2000/svg"
                            class="h-7 w-7 text-red-600 fill-red-600" viewBox="0 0 24 24">
                            <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 
                    4.42 3 7.5 3c1.74 0 3.41 0.81 4.5 2.09C13.09 3.81 
                    14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 
                    6.86-8.55 11.54L12 21.35z" />
                        </svg>

                        <svg v-else xmlns="http://www.w3.org/2000/svg" class="h-7 w-7 text-gray-400 hover:text-red-500"
                            fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.8">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M4.318 6.318a4.5 4.5 0 016.364 0L12 
                     7.636l1.318-1.318a4.5 4.5 0 116.364 6.364L12 
                     21l-7.682-7.682a4.5 4.5 0 010-6.364z" />
                        </svg>
                    </button>

                    <div v-if="project.urgency_level"
                        class="absolute top-4 left-4 px-3 py-1 text-xs font-semibold rounded-full" :class="{
                            'bg-red-100 text-red-600': project.urgency_level === 'high',
                            'bg-yellow-100 text-yellow-700': project.urgency_level === 'medium',
                            'bg-green-100 text-green-700': project.urgency_level === 'low'
                        }">
                        {{
                            project.urgency_level === 'high' ? 'URGENTE' :
                                project.urgency_level === 'medium' ? 'Normal' : 'Flexível'
                        }}
                    </div>

                    <div>
                        <h3 class="text-xl font-semibold text-[#152a34] mb-2 mt-4 line-clamp-2">
                            <router-link
                                :to="projectDetailsPath(project)"
                                class="hover:text-[#b99a52] transition"
                                @click="trackProjectView(project)"
                                @auxclick.middle="trackProjectView(project)"
                            >
                                {{ project.title }}
                            </router-link>
                        </h3>

                        <p class="text-gray-600 text-sm mb-4 h-[70px] overflow-hidden leading-5">{{
                            truncate(project.description) }}</p>

                        <div v-if="project.categories && project.categories.length" class="flex flex-wrap gap-1.5 mt-2">
                            <span v-for="cat in project.categories.slice(0, 3)" :key="cat"
                                class="px-2 py-0.5 text-[11px] bg-[#f4efe6] border border-[#d6c7a5] text-[#6d5d3a] rounded-full">
                                {{ cat }}
                            </span>
                        </div>

                        <div class="flex flex-wrap gap-2 mb-4">
                            <span v-for="tag in project.tags" :key="tag"
                                class="px-3 py-1 bg-[#f6f4f1] border border-[#e0dcd6] rounded-full text-xs">
                                {{ tag }}
                            </span>
                        </div>
                    </div>

                    <div class="flex justify-between text-xs text-gray-500 mb-3">
                        <span>📅 {{ formatDateLocal(project.created_at) }}</span>
                        <span>💬 {{ project.proposals_count }} propostas</span>
                    </div>

                    <!-- 👁️ CONTADOR DE VISUALIZAÇÕES -->
                    <div class="flex justify-between items-center text-xs text-gray-500 mb-3">
                        <div class="flex items-center gap-1">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24"
                                stroke="currentColor" stroke-width="2">
                                <path stroke-linecap="round" stroke-linejoin="round"
                                    d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                <path stroke-linecap="round" stroke-linejoin="round" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.477 0 8.268 2.943 
                                    9.542 7-1.274 4.057-5.065 7-9.542 7-4.477 
                                    0-8.268-2.943-9.542-7z" />
                            </svg>
                            <span>{{ project.views_count }}</span>
                        </div>

                        <!-- STATUS DO PROJETO -->
                        <span class="inline-block px-3 py-0.5 text-xs font-semibold rounded-full" :class="{
                            'bg-blue-100 text-blue-700': project.status === 'open',
                            'bg-yellow-100 text-yellow-700': project.status === 'in_progress',
                            'bg-purple-100 text-purple-700': project.status === 'awaiting_payment',
                            'bg-orange-100 text-orange-700': project.status === 'awaiting_approval',
                            'bg-emerald-100 text-emerald-700': project.status === 'payment_approved',
                            'bg-green-100 text-green-700': project.status === 'completed',
                            'bg-red-100 text-red-700': project.status === 'cancelled',
                            'bg-fuchsia-100 text-fuchsia-700': project.status === 'dispute_opened',
                            'bg-amber-100 text-amber-700': project.status === 'cancel_requested'
                        }">
                            {{
                                project.status === 'open' ? 'Aberto' :
                                    project.status === 'in_progress' ? 'Em andamento' :
                                        project.status === 'awaiting_payment' ? 'Aguardando pagamento' :
                                            project.status === 'awaiting_approval' ? 'Aguardando aprovação' :
                                                project.status === 'payment_approved' ? 'Pagamento aprovado' :
                                                    project.status === 'completed' ? 'Concluído' :
                                                        project.status === 'dispute_opened' ? 'Disputa aberta' :
                                                            project.status === 'cancel_requested' ? 'Cancelamento solicitado' :
                                                                'Cancelado'
                            }}
                        </span>

                    </div>


                    <div class="mt-4">
                        <!--<p class="text-[#b99a52] font-bold text-lg mb-3">
                            R$ {{ parseFloat(project.budget).toFixed(2).replace('.', ',') }}
                        </p>-->

                        <router-link
                            :to="projectDetailsPath(project)"
                            class="block w-full text-center px-4 py-2 rounded-full bg-[#b99a52] hover:bg-[#a18446] text-white transition font-semibold"
                            @click="trackProjectView(project)"
                            @auxclick.middle="trackProjectView(project)"
                        >
                            Ver detalhes
                        </router-link>
                    </div>
                </div>

            </div>

        </section>

        <!-- 📌 PAGINAÇÃO – agora no lugar correto -->
        <div class="max-w-7xl mx-auto w-full px-4 mt-4 mb-4">
            <div class="flex justify-center gap-2 w-full flex-wrap px-4 sm:px-0">
                <button v-for="(page, idx) in visiblePages.filter(p => p !== totalPages)" :key="`${page}-${idx}`" @click="goToPage(page)"
                    class="px-3 py-2 sm:px-4 border rounded-xl transition text-sm" :disabled="page === '...'" :class="[
                        page === '...' ? 'bg-white text-gray-400 cursor-default' :
                            currentPage === page ? 'bg-[#b99a52] text-white border-[#b99a52]' :
                                'bg-white hover:bg-gray-100'
                    ]">
                    {{ page }}
                </button>
            </div>
            <!-- vazio -->
            <div v-if="projects.length === 0" class="text-center text-gray-500 mt-10 w-full">
                Nenhum projeto encontrado.
            </div>

        </div>

        <AppFooter />
    </div>
</template>

<script setup>
import { ref, computed, onMounted, watch, getCurrentInstance, nextTick } from "vue";
import AppFooter from "@/components/AppFooter.vue";
import AppHeader from "./AppHeader.vue";
import api from '@/services/api';
import { useRoute } from 'vue-router';
import { useLoadingStore } from '@/store/loadingStore';

const loadingStore = useLoadingStore();
const route = useRoute();
const showFilters = ref(false);
const projects = ref([]);
const { proxy } = getCurrentInstance()

const currentPage = ref(1);
const perPage = 9;
const totalPages = ref(1);
const maxButtons = computed(() => (window.innerWidth < 480 ? 5 : 7))

const categorySearch = ref('')
const categoryOptions = ref([])
const categoryLoading = ref(false)
const categoryDropdownDesktopRef = ref(null)
const categoryDropdownMobileRef = ref(null)
const categoryDropdownStyle = ref({})
const selectedCategories = ref([])

function clipDropdownToViewport (dropdownEl, styleRef) {
  if (!dropdownEl) return
  nextTick(() => {
    const vvHeight = window.visualViewport?.height ?? window.innerHeight
    const rect = dropdownEl.getBoundingClientRect()
    const available = vvHeight - rect.top - 8
    if (available > 0 && available < rect.height) {
      styleRef.value = { maxHeight: Math.max(available, 80) + 'px' }
    } else {
      styleRef.value = {}
    }
  })
}

function onCategorySearch (event) {
  if (event?.target) categorySearch.value = event.target.value
  clearTimeout(catTimer)

  const term = categorySearch.value.trim()
  if (term.length < 2) {
    categoryOptions.value = []
    categoryLoading.value = false
    return
  }

  categoryLoading.value = true

  catTimer = setTimeout(async () => {
    try {
      const { data } = await api.get('/categories', { params: { search: term, type: 'remote', limit: 20 } })
      categoryOptions.value = data.data || []
      if (categoryOptions.value.length) {
        clipDropdownToViewport(categoryDropdownDesktopRef.value, categoryDropdownStyle)
        clipDropdownToViewport(categoryDropdownMobileRef.value, categoryDropdownStyle)
      }
    } catch {
      categoryOptions.value = []
    } finally {
      categoryLoading.value = false
    }
  }, 250)
}

const filters = ref({
    search: "",
    category: "",
    status: [],
    urgency: [],
    budgetMin: "",
    budgetMax: "",
    proposals: "",
    date: "",
    deadline: "",
    order: "recent"
});

function truncate(text, size = 65) {
    if (!text) return "";
    return text.length > size ? text.substring(0, size) + "..." : text;
}

function formatDateLocal(dateValue) {
    if (!dateValue) return "";
    let str = String(dateValue).trim();
    if (str && !/Z|[+-]\d{2}:?\d{2}$/.test(str)) {
        str = str.replace(" ", "T") + "+03:00";
    }
    const d = new Date(str);
    if (Number.isNaN(d.getTime())) return String(dateValue);
    return d.toLocaleDateString("pt-BR", { timeZone: "America/Sao_Paulo" });
}

watch(filters, (val) => {
    localStorage.setItem("wm_filters", JSON.stringify(val));
}, { deep: true });

const getProjects = async () => {
    try {
        loadingStore.show();

        const params = {
            page: currentPage.value,
            per_page: perPage,
            search: filters.value.search || undefined,
            category: filters.value.category || undefined,
            status: filters.value.status.length ? filters.value.status.join(',') : undefined,
            urgency: filters.value.urgency.length ? filters.value.urgency.join(',') : undefined,
            proposals: filters.value.proposals || undefined,
            date: filters.value.date || undefined,
            deadline: filters.value.deadline || undefined,
            order: filters.value.order || undefined,
            categories: selectedCategories.value.length ? selectedCategories.value.join(',') : undefined,
        };

        const { data } = await api.get('/projects', { params });

        projects.value = data.data || [];
        totalPages.value = data.lastPage || 1;

    } catch (error) {
        proxy.$swal.fire({ icon: "error", title: "", text: "Erro ao carregar projetos." });
    } finally {
        loadingStore.hide();
    }
};

const favorites = ref([]);

let catTimer = null


function addCategory(desc) {
    if (!desc) return
    if (!selectedCategories.value.includes(desc)) selectedCategories.value.push(desc)
    categorySearch.value = ''
    categoryOptions.value = []
    categoryDropdownStyle.value = {}
}

function removeCategory(desc) {
    selectedCategories.value = selectedCategories.value.filter(x => x !== desc)
}

onMounted(async () => {
    // favoritos
    const saved = localStorage.getItem("wm_favorites");
    if (saved) favorites.value = JSON.parse(saved);

    // filtros salvos
    const savedFilters = localStorage.getItem("wm_filters");
    if (savedFilters) {
        filters.value = { ...filters.value, ...JSON.parse(savedFilters) };
    }

    // suporte ao parâmetro ?q= na URL (usado pelo Google Sitelinks Searchbox)
    const querySearch = route.query.q;
    if (querySearch) {
        filters.value.search = String(querySearch);
    }

    await getProjects();
});


const toggleFavorite = async (projectId) => {
    const exists = favorites.value.includes(projectId);

    // snapshot
    const previous = [...favorites.value];

    if (exists) {
        favorites.value = favorites.value.filter(id => id !== projectId);
    } else {
        favorites.value.push(projectId);
    }

    localStorage.setItem("wm_favorites", JSON.stringify(favorites.value));

    try {
        await api.post('/favorites/toggle', { project_id: projectId });
    } catch (e) {
        favorites.value = previous;
        localStorage.setItem("wm_favorites", JSON.stringify(previous));

        proxy.$swal.fire({
            icon: "error",
            text: "Erro ao favoritar."
        });
    }
};

const nextPage = () => {
    if (currentPage.value < totalPages.value) {
        currentPage.value++;
        scrollToTopOfList();
    }
};

const prevPage = () => {
    if (currentPage.value > 1) {
        currentPage.value--;
        scrollToTopOfList();
    }
};

const goToPage = (page) => {
    if (page === "..." || page === currentPage.value) return;
    currentPage.value = page;
    scrollToTopOfList();
};

const visiblePages = computed(() => {
    const total = totalPages.value;
    const current = currentPage.value;
    const max = maxButtons.value;

    if (total <= max) {
        return Array.from({ length: total }, (_, i) => i + 1);
    }

    // max inclui: primeiro + último + miolo (+ reticências se precisar)
    const pages = [];
    const first = 1;
    const last = total;

    const middleSlots = max - 2; // quantos números no meio no máximo

    // tenta centralizar o current no meio
    let start = Math.max(2, current - Math.floor(middleSlots / 2));
    let end = start + middleSlots - 1;

    if (end > total - 1) {
        end = total - 1;
        start = end - middleSlots + 1;
    }

    pages.push(first);

    if (start > 2) pages.push("...");

    for (let p = start; p <= end; p++) pages.push(p);

    if (end < total - 1) pages.push("...");

    pages.push(last);

    return pages;
});

const scrollToTopOfList = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
};

watch(currentPage, () => {
    getProjects();
});

const projectDetailsPath = (project) => `/projeto/${project.hash}/${project.slug}`;

const trackProjectView = (project) => {
    api.post(`/project/view/${project.hash}/${project.slug}`, {
        hash: project.hash,
        slug: project.slug
    }).catch(() => {});
};

const applyFilters = () => {
    currentPage.value = 1;
    getProjects();
};
</script>


<style scoped>
.line-clamp-3 {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

@keyframes slideLeft {
    from {
        transform: translateX(-100%);
    }

    to {
        transform: translateX(0);
    }
}

.animate-slideLeft {
    animation: slideLeft 0.25s ease-out;
}
</style>
